<template>
  <div
    class="stock-wrap"
    key="2"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button type="primary" @click="onAdd" v-if="funcView.schedules_add">{{ $t('base_schedules.tui_song_ji_hua') }}</el-button>
        </el-form-item>
        <el-form-item
          style="float: right"
          class="mr-0"
        >
          <custom-column ref="column1"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            :placeholder="$t('base_schedules.zu_zhi_ming_cheng')"
            v-model="formSearch.orgName"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            :placeholder="$t('base_schedules.chuang_jian_gong_si')"
            v-model="formSearch.creatorOrgName"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['realName', 'periodType', 'pushMethod', 'pushTime', 'action']"
        tableCode="schedules_list"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
        columnRef="column1"
      >
        <template
          slot="realName"
          slot-scope="scope"
        >

           {{ scope.row.realname||'-' }} / {{ scope.row.userName||'-'  }}
        </template>
        <template slot="periodType" slot-scope="scope">
          {{ formatPeriodType(scope.row) }}
        </template>
        <template slot="pushMethod" slot-scope="scope">
          {{ formatPushMethod(scope.row) }}
        </template>
        <template slot="pushTime" slot-scope="scope">
          {{ formatPushTime(scope.row.pushTime) }}
        </template>
        <template slot="action" slot-scope="scope">
          <el-button v-if="funcView.schedules_edit" type="text" size="mini" @click="onEdit(scope.row)">{{ $t('Common.com_edit') }}</el-button>
          <el-button v-if="funcView.schedules_delete" type="text" size="mini" @click="onDelete(scope.row)">{{ $t('Common.com_delete') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 定时推送新增 -->
    <timing-push-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
    ></timing-push-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import timingPushDialog from './schedules_timing_push_dialog.vue';

export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: {
    timingPushDialog,
  },
  props: {},
  data() {
    return {
      tableSelect: [],
      formSearch: {
        creatorOrgName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        dataTimes: [],
        orgName: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      // IST 站点列表
      istList: [],
      periodTypeDict: {},
      reportTypeDict: {},
      pushMethodDict: {},
      weekTypeDict: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    initDicts() {
      this.getDictionary('report_export_period_type,report_export_type,report_export_push_method,week_type', (dictionary) => {
        this.periodTypeDict = this.getDictMap(dictionary.report_export_period_type);
        this.reportTypeDict = this.getDictMap(dictionary.report_export_type);
        this.pushMethodDict = this.getDictMap(dictionary.report_export_push_method);
        this.weekTypeDict = this.getDictMap(dictionary.week_type);
      });
    },
    getDictMap(list) {
      return (list || []).reduce((acc, item) => {
        acc[String(item.value)] = item.name;
        return acc;
      }, {});
    },
    formatPeriodType(row) {
      const periodType = String(row.periodType || '');
      if (periodType === '1') {
        return this.periodTypeDict[periodType] || '-';
      }
      if (periodType === '2') {
        const periodValue = row.periodValue || '-';
        const reportTypeName = this.reportTypeDict[String(row.reportType)] || '';
        return `${periodValue} ${reportTypeName}`.trim();
      }
      return '-';
    },
    formatPushCondition(row) {
      const values = String(row.pushCondition || '')
        .split(',')
        .map(item => item.trim())
        .filter(item => item);
      if (!values.length) {
        return '';
      }
      if (this.isMonthDayPush(row)) {
        const dayList = values.map(item => Number(item)).filter(item => !Number.isNaN(item));
        return dayList.length ? this.$t('base_schedules.mei_yueori', [dayList.join(this.$t('base_schedules.ri'))]) : '';
      }
      const weekList = values.map(item => this.weekTypeDict[String(item)]).filter(item => item);
      return weekList.length ? this.$t('base_schedules.meio', [weekList.join('、')]) : '';
    },
    isMonthDayPush(row) {
      const pushMethod = String(row.pushMethod || '');
      const reportType = String(row.reportType || '');
      const periodType = String(row.periodType || '');
      return ['1', '3'].includes(pushMethod) || (reportType === '1' && periodType === '1');
    },
    formatPushMethod(row) {
      const pushCondition = this.formatPushCondition(row);
      return pushCondition || '-';
    },
    formatPushTime(value) {
      const t = String(value || '').trim();
      if (!t) {
        return '-';
      }
      return `${t.slice(0, 2)}:${t.slice(2, 4)}`;
    },
    initIstList() {
      const reqUrl = apis.websiteSelectList;
      const reqData = { websiteEnv: this.websiteEnv, websiteType: 1 };
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.istList = res.data || [];
      });
    },
    getWebsiteName(row) {
      const istList = this.istList;
      if (istList.length) {
        const item = istList.find(obj => obj.websiteCode === row.websiteCode);
        if (item) {
          return item.websiteName;
        }
      }
      return row.websiteName || '-';
    },
    websiteNameChange() {
      this.formSearch.productCode = '';
    },
    // 获取列表
    getTableList() {
      this.formSearch.outStartTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.outEndTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.$getJSON(apis.workReportSchedulePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },

    // 数据导出
    exportTable: function () {
      const reqData = {
        ...this.formSearch
      };
      delete reqData.pageSize;
      delete reqData.pageNum;

      this.$exportFlie(apis.factoryStockExport, reqData);
    },
    // 编辑
    onEdit(row) {
      this.dialogModel.title = this.$t('Common.com_edit');
      this.dialogModel.type = 'edit';
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    // 新增
    onAdd() {
      this.dialogModel = {
        title: this.$t('base_schedules.ding_shi_tui_song'),
      };
      this.dialogVisible = true;
    },
    // 删除
    onDelete: function (row) {
      this.$showConfirm(this.$t('base_schedules.nqdscsxtsjhm'))
        .then(() => {
          this.$postJSON(`${apis.workReportScheduleDelete}/${row.genScheduleId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.onPageChange({ page: 1 });
          });
        })
        .catch(() => {});
    },
  },
  created() { },
  mounted() {
    this.initIstList();
    this.getTableList();
    this.getFuncView();
    this.initDicts();
  },
};
</script>

<style></style>
